export const enum NewsSaveStatusType {
  SAVING = 'SAVING',
  SAVED = 'SAVED',
  SAVE_ERROR = 'SAVE_ERROR',
  NONE = 'NONE',
}
